import { render, staticRenderFns } from "./UserControlBox.vue?vue&type=template&id=5fb839b6&scoped=true"
import script from "./UserControlBox.vue?vue&type=script&lang=js"
export * from "./UserControlBox.vue?vue&type=script&lang=js"
import style0 from "./UserControlBox.vue?vue&type=style&index=0&id=5fb839b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb839b6",
  null
  
)

export default component.exports